import { useSmartProp } from '@smartfire/js-block-engine';
import { PanelBody, PanelRow, ToggleControl } from '@wordpress/components';

export const Inspector = () => {
    const [reverseMobile, setReverseMobile] = useSmartProp('reverseMobile');
    const [largeGap, setLargeGap] = useSmartProp('largeGap');
    const [isContentWidth, setIsContentWidth] = useSmartProp('isContentWidth');

    return (
        <PanelBody title="Paramètres" initialOpen={true}>
            <PanelRow>
                <ToggleControl label="Espacement des colonnes plus large" checked={largeGap} onChange={setLargeGap} />
            </PanelRow>
            <PanelRow>
                <ToggleControl
                    label="Inverser les colonnes sur mobile"
                    checked={reverseMobile}
                    onChange={setReverseMobile}
                />
            </PanelRow>
            <PanelRow>
                <ToggleControl label="Conteneur" checked={isContentWidth} onChange={setIsContentWidth} />
            </PanelRow>
        </PanelBody>
    );
};

export default Inspector;
